import React from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";

Number.prototype.format = function (n, x) {
  var re = "\\d(?=(\\d{" + (x || 3) + "})+" + (n > 0 ? "\\." : "$") + ")";
  return this.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, "g"), "$&,");
};

const TextFieldHelper = (props) => {
  const {
    label,
    title,
    fieldName,
    values,
    handleChange,
    touched,
    errors,
    multiline,
    disabled,
    type,
    rows,
  } = props;

  if (props.select)
    return (
      <FormControl fullWidth={true}>
        <InputLabel id="demo-simple-select-outlined-label">{title}</InputLabel>{" "}
        <Select
          fullWidth
          labelId="demo-simple-select-outlined-label"
          variant={"outlined"}
          id={fieldName}
          name={fieldName}
          label={title}
          value={
            props.isNumber && values[fieldName] && values[fieldName] !== ""
              ? parseInt(
                  values[fieldName].toString().replaceAll(",", ""),
                ).format()
              : values[fieldName] || ""
          }
          onChange={(e) => {
            let d = e.target.value;

            props.isNumber && e.target.value !== ""
              ? props.setFieldValue(fieldName, d.replaceAll(",", ""))
              : handleChange(e);
          }}
          error={touched[fieldName] && Boolean(errors[fieldName])}
          disabled={disabled}
        >
          {Array.isArray(props.options)
            ? props.options.map((val) => {
                return (
                  <MenuItem key={val.value} value={val.value}>
                    {val.label}
                  </MenuItem>
                );
              })
            : null}
        </Select>
      </FormControl>
    );

  return (
    <TextField
      multiline={multiline}
      fullWidth
      variant={"outlined"}
      id={fieldName}
      name={fieldName}
      label={title}
      value={
        props.isNumber && values[fieldName] && values[fieldName] !== ""
          ? parseInt(values[fieldName].toString().replaceAll(",", "")).format()
          : values[fieldName] || ""
      }
      onChange={(e) => {
        let d = e.target.value;

        props.isNumber && e.target.value !== ""
          ? props.setFieldValue(fieldName, d.replaceAll(",", ""))
          : handleChange(e);
      }}
      type={type ? type : "text"}
      error={touched[fieldName] && Boolean(errors[fieldName])}
      helperText={touched[fieldName] && errors[fieldName]}
      disabled={disabled}
      rows={rows}
    />
  );
};

export default React.memo(TextFieldHelper);
